export const Header = `
    <Header 
        reverseColor={true} // false (default) white background or true for reversed color
        size="lg" // "sm" (default) mostly used in apps, "md" and "lg" used for marketing
        className="custom-class" // If needed
        Title "Title" // Optional
    >
        <Button color="secondary" label="Action"/>
    </Header>
`
